import type { CreateServiceRequest } from "@/types/api";
import { postgresCredentialError } from "./connectionCredentials";

export type PostgresWriteMode = "insert" | "upsert";

export function toPostgresPayload(
  connectionString: string,
  writeMode: PostgresWriteMode,
): Partial<CreateServiceRequest> {
  const connection = connectionString.trim();
  if (!connection) throw new Error("PostgreSQL connection string is required");
  if (!/^postgres(?:ql)?:\/\//i.test(connection)) {
    throw new Error("Use a postgresql:// or postgres:// connection string");
  }
  // Checked on Add (TTTL-84): the throw lands in the error toast and
  // keeps the submit from reaching the server, where the driver would
  // misread the host.
  const credentialError = postgresCredentialError(connection);
  if (credentialError) throw new Error(credentialError);
  return { connection_string: connection, write_mode: writeMode };
}
